// extracted by mini-css-extract-plugin
export default {"Container":"PointsList_Container__CVzrx"};